export const prefix = (name: string): string => `Docs--${name}`;
